import { Link, Outlet } from '@tanstack/react-router';
import styles from './RootLayout.module.css';

/** App shell: header nav, with the active route rendered below. */
export function RootLayout() {
  return (
    <div className={styles.shell}>
      <header className={styles.header}>
        <Link to="/" className={styles.brand}>
          <span className={styles.brandMark} aria-hidden="true" />
          <span>
            Patch<span className={styles.brandAccent}>Probe</span>
          </span>
        </Link>

        <nav className={styles.nav}>
          <Link to="/" className={styles.link} activeProps={{ className: styles.active }}>
            Home
          </Link>
          <Link to="/audit" className={styles.link} activeProps={{ className: styles.active }}>
            Audit
          </Link>
        </nav>

        <span className={styles.sources} aria-hidden="true">
          deps.dev ∙ osv.dev ∙ nvd
        </span>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
